$(document).ready(function() {
  var checkExist = setInterval(function () {
    if ($('div.healcode.appointments').length) {
      updateUi();
      clearInterval(checkExist);
    }
  }, 100);
  
  function updateUi() {
    var servicesSelect = $('.pre-filters div:nth-child(1) select').clone();
    var therapistSelect = $('.pre-filters div:nth-child(2) select').clone();
    var calendar = $('.ui-datepicker-inline').clone();
    
    document.getElementById("hc-find-appt-spinner").src="https://cdn.shopify.com/s/files/1/0045/0907/3478/files/three_dots_loading.svg?v=1652467496";

    $('.ui-datepicker-prev .ui-icon').css('background-image', 'https://cdn.shopify.com/s/files/1/0045/0907/3478/files/Vector_3.svg?v=1652389613');
    $('.ui-datepicker-next .ui-icon').css('background-image', 'https://cdn.shopify.com/s/files/1/0045/0907/3478/files/Vector_3.svg?v=1652389613');
    
    servicesSelect.attr('id', servicesSelect.attr('id') + '__clone');
    therapistSelect.attr('id', therapistSelect.attr('id') + '__clone');
    
    $('#selections').append(servicesSelect);
    $('#selections').append(therapistSelect);
//     $('#calendar').append(calendar);
    
    $('#selections select').change(function() {
      var id = $(this).attr('id').replace('__clone', '');
      var val = $(this).val();
      $(`#${id} option[value="${val}`).prop('selected', true);
    });
    
    $('td[data-event="click"]').click(function(){
      $('.signup_now').click();
    });

    $('.signup_now').on('click', function() {
      setTimeout(function() {
        $('.signup_now').css('display', 'block').addClass('disabled');
        $('#results').empty();
      }, 5);
      
      setTimeout(function() {
        var isLoading = setInterval(function () {
          if (!$('#hc-find-appt-spinner').is(":visible")) {
            $('.signup_now').removeClass('disabled');
            var results = $('#appointment_results').clone();
            
            $('#results').html(results);

            clearInterval(isLoading);
          }
        }, 100);
      }, 10);
    });
  }

  var service = '';
  var locationId = 'b617fb52-400d-4b5d-8747-8928fed24fa3';

  if (typeof LOCATION_ID !== 'undefined') {
    locationId = LOCATION_ID;
  } 
  
  
  $('.booking-select').change(function(){
  	$(this).next().removeClass('disable').prop('disabled' , false);
    
    service = $('option:selected', $(this)).data('blvd');
  })
  
  $('.booking-div button').click(function(e){
    e.preventDefault();

    if (window.location.search.includes('konsisttest')||true) {
      blvd.openBookingWidget({ urlParams: { locationId: locationId, path: '/cart/menu/'+service, visitType: 'SELF_VISIT' }});
      return;
    }
      
    $('body').css({
      overflow: 'hidden',
      height: '100vh'
    });
    
    $('.booking-container').fadeIn();
    $('.booking-sys').css('bottom','0');
    
    var value = $(this).prev().val();
    $(`#session_type__clone option[value="${value}`).prop('selected',true).change()
  });
  
  $(document).mouseup(function(e) {
    var container = $(".booking-sys");

    // if the target of the click isn't the container nor a descendant of the container
    if (!container.is(e.target) && container.has(e.target).length === 0) 
    {
      $('.booking-container').fadeOut();
      container.css('bottom', '-100%');

      $('body').css({
        overflow: 'auto',
        height: 'auto'
      });
    }
  });

  // If in a partner page, remove grounded options
  // IMPORTANT - page needs to have the "partner-" suffix in the template name
  if ($('body').hasClassRegEx('partner-*')) {
    $('.booking-select').each(function() {
      $('optgroup', $(this)).each(function() {
        console.log($(this));
        if ($(this).attr('label') != 'Mobile') {
          $(this).remove();
        }
      });
    });
  }
});

(function($)
{
	$.fn.hasClassRegEx = function(regex)
	{
		var classes = $(this).attr('class');

		if(!classes || !regex){ return false; }

		classes = classes.split(' ');
		var len = classes.length;

		for(var i=0; i<len; i++)
		{
			if(classes[i].match(regex)){ return true; }
		}

		return false;
	};
})(jQuery);
